import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  MultiCustomersPaymentAgingCriteriaBean,
  CustomerPaymentAgingHistoryCriteriaBean,
  MultiCustomersOnlineAgingPrintRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  PageListBean,
  RestReadRequest,
} from "../../Ds/ds";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  ColumnDefinition,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_THEME_COLOR,
  TOAST_WARN,
} from "../../Utils/appConstants";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import { MINUSICON, PLUSICON } from "../../Utils/icons";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import Modal from "../../Components/Modal";
import MobileCardTable from "../../Components/MobileCardTable";
// import MobileCardTable from ".."
// const cardStyles = {
//   card: {
//     background: "var(--color-background-primary, #fff)",
//     border: "0.5px solid var(--color-border-tertiary, #e0e0e0)",
//     borderRadius: "12px",
//     padding: "16px 20px",
//   },
//   avatar: {
//     width: "48px", height: "48px", minWidth: "48px",
//     borderRadius: "50%",
//     background: "#EEEDFE", color: "#534AB7",
//     display: "flex", alignItems: "center", justifyContent: "center",
//     fontWeight: 600, fontSize: "15px",
//   },
//   badgeWarn: {
//     fontSize: "11px", fontWeight: 500, padding: "4px 12px",
//     borderRadius: "999px", background: "#FAEEDA", color: "#854F0B",
//   },
//   badgeOk: {
//     fontSize: "11px", fontWeight: 500, padding: "4px 12px",
//     borderRadius: "999px", background: "#EAF3DE", color: "#3B6D11",
//   },
//   metricsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
//     gap: "10px",
//   },
//   tile: {
//     background: "var(--color-background-secondary, #f5f5f7)",
//     borderRadius: "8px", padding: "12px 14px", textAlign: "center",
//   },
//   tileLabel: {
//     fontSize: "11px", color: "var(--color-text-secondary, #888)",
//     textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px",
//   },
//   tileValue: {
//     fontSize: "17px", fontWeight: 600,
//     color: "var(--color-text-primary, #1a1a2e)",
//   },
//   tileLink: {
//     fontSize: "17px", fontWeight: 600,
//     background: "none", border: "none", padding: 0,
//     textDecoration: "underline", cursor: "pointer",
//     display: "block", width: "100%", textAlign: "center",
//   },
//   tileHint: {
//     fontSize: "10px",
//     color: "var(--color-text-secondary, #888)",
//     marginTop: "3px",
//   },
//   sectionTitle: {
//     fontSize: "11px", fontWeight: 600,
//     color: "var(--color-text-secondary, #888)",
//     textTransform: "uppercase", letterSpacing: "0.06em",
//     margin: "0 0 12px",
//   },
//   agingGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
//     gap: "14px",
//   },
//   bar: {
//     height: "7px",
//     background: "var(--color-background-secondary, #ebebeb)",
//     borderRadius: "4px", overflow: "hidden",
//   },
//   barFill: {
//     height: "100%", borderRadius: "4px",
//     transition: "width 0.4s ease",
//   },
//   fieldRow: {
//     display: "flex", justifyContent: "space-between",
//     padding: "5px 0", fontSize: "13px",
//     borderBottom: "0.5px solid var(--color-border-tertiary, #e0e0e0)",
//   },
//   fieldLabel: { color: "var(--color-text-secondary, #888)" },
//   fieldValue: { fontWeight: 500, color: "var(--color-text-primary, #1a1a2e)" },
// };


function getRatingClass(rating) {
  if (rating >= 3) return "bg-red";
  if (rating === 2) return "bg-pink";
  if (rating === 1) return "bg-yellow";
  return "bg-green";
}

/* ─── Donut ring SVG ─── */
function DonutRing({ pct, color, emptyColor }) {
  const r = 22;
  const circ = 2 * Math.PI * r;
  const dash = (pct / 100) * circ;
  return (
    <svg className="acv2-ring" width="60" height="60" viewBox="0 0 60 60">
      <circle cx="30" cy="30" r={r} fill="none" stroke={emptyColor} strokeWidth="4" />
      <circle
        cx="30" cy="30" r={r} fill="none"
        stroke={color} strokeWidth="4"
        strokeDasharray={`${dash} ${circ}`}
        strokeLinecap="round"
        transform="rotate(-90 30 30)"
      />
      <text
        x="30" y="34" textAnchor="middle"
        fontSize="10" fontWeight="600"
        fill={pct > 0 ? color : "var(--text-color)"}
      >
        {Math.round(pct)}%
      </text>
    </svg>
  );
}

/* ─── Single bucket card inside aging step ─── */
function BucketCard({ bucket, totalDue }) {
  const pct = totalDue > 0 ? (bucket.value / totalDue) * 100 : 0;
  const isHot = bucket.value > 0;
  const fmt = (val) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
      .format(parseFloat(val) || 0);
  return (
    <div className={`acv2-bucket-card${isHot ? " acv2-bucket-card--hot" : ""}`}>
      <div className="acv2-bucket-top-bar" style={{ background: bucket.color }} />
      <div className="acv2-bucket-inner">
        <DonutRing
          pct={pct}
          color={bucket.color}
          emptyColor={isHot ? bucket.bg : "var(--table-border)"}
        />
        <div className="acv2-bucket-info">
          <span
            className="acv2-bucket-pill"
            style={{
              background: isHot ? bucket.bg : "var(--table-row-even)",
              color: isHot ? bucket.textColor : "var(--text-color)",
              borderColor: isHot ? bucket.color : "var(--card-border)",
            }}
          >
            {bucket.label}
          </span>
          <div className={`acv2-bucket-amount${isHot ? " acv2-bucket-amount--hot" : ""}`}>
            {fmt(bucket.value)}
          </div>
          <div className="acv2-bucket-pct">{Math.round(pct)}% of total</div>
        </div>
      </div>
      {isHot && (
        <div className="acv2-bucket-bar-wrap">
          <div
            className="acv2-bucket-bar-fill"
            style={{ width: `${pct}%`, background: bucket.color }}
          />
        </div>
      )}
    </div>
  );
}

/* ══════════════════════════════════════════════════
   AgingCustomerCard — 4-step swipeable card view
   ══════════════════════════════════════════════════ */
function AgingCustomerCard({ data, onInvoiceClick, onCreditClick }) {
  const [step, setStep] = useState(0);
  const [touchStart, setTouchStart] = useState(null);

  if (!data) return null;

  const fmt = (val) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
      .format(parseFloat(val) || 0);

  const totalDue   = parseFloat(data.totalInvoiceDueAmount) || 0;
  const lastPayAmt = parseFloat(data.lastPaymentAmount) || 0;
  const unApplied  = parseFloat(data.totalUnAppliedCreditMemoAmount) || 0;
  const provPaid   = parseFloat(data.totalProvisionalAppliedAmount) || 0;
  const currentAge = parseFloat(data.currentAgeAmount) || 0;
  const age1       = parseFloat(data.ageAmount1) || 0;
  const age2       = parseFloat(data.ageAmount2) || 0;
  const age3       = parseFloat(data.ageAmount3) || 0;
  const age4       = parseFloat(data.ageAmount4) || 0;
  const isOverdue  = age1 > 0 || age2 > 0 || age3 > 0 || age4 > 0;

  const initials = data.customerName
    ? data.customerName.split(/[\s\-,]+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "??";

  const agingBuckets = [
    { label: "Current",    value: currentAge, color: "#639922", bg: "#EAF3DE", textColor: "#3B6D11" },
    { label: "1–30 days",  value: age1,       color: "#E24B4A", bg: "#FCEBEB", textColor: "#791F1F" },
    { label: "31–60 days", value: age2,       color: "#E24B4A", bg: "#FCEBEB", textColor: "#791F1F" },
    { label: "61–90 days", value: age3,       color: "#BA7517", bg: "#FAEEDA", textColor: "#633806" },
    { label: "90+ days",   value: age4,       color: "#A32D2D", bg: "#FCEBEB", textColor: "#501313" },
  ];

  const STEPS = 4;
  const stepLabels = ["Profile", "Aging", "Payment", "Balance"];

  const goTo = (n) => setStep(Math.max(0, Math.min(STEPS - 1, n)));
  const handleTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goTo(step + (diff > 0 ? 1 : -1));
    setTouchStart(null);
  };

  /* ── Step 0: Profile ── */
  const StepProfile = (
    <div className="acv2-step">
      <div className="acv2-hero-banner">
        <div className="acv2-avatar">{initials}</div>
        <div className="acv2-hero-info">
          <div className="acv2-hero-name">{data.customerName}</div>
          <div className="acv2-hero-meta">
            <span>#{data.customerCode}</span>
            {data.salesPersonCodes && <span>· {data.salesPersonCodes}</span>}
            {data.phone1 && (
              <span className="acv2-phone-inline">
                ·
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.6 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.07 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                {data.phone1}
              </span>
            )}
            <span className={getRatingClass(data.rating)} style={{ width: 10, height: 10, borderRadius: 2, display: "inline-block" }} />
          </div>
        </div>
        <span className={isOverdue ? "acv2-badge acv2-badge--warn" : "acv2-badge acv2-badge--ok"}>
          {isOverdue ? "Overdue" : "Current"}
        </span>
      </div>

      <div className="acv2-kpi-grid">
        <div className="acv2-kpi">
          <div className="acv2-kpi-label">Total Due</div>
          <button
            className={`acv2-kpi-val acv2-kpi-link${totalDue > 0 ? " acv2-kpi-val--danger" : ""}`}
            onClick={(e) => onInvoiceClick && onInvoiceClick(e, data.totalInvoiceDueAmount, data)}
          >{fmt(totalDue)}</button>
          <div className="acv2-kpi-hint">view invoices</div>
        </div>
        <div className="acv2-kpi">
          <div className="acv2-kpi-label">Unapplied Credit</div>
          <button
            className={`acv2-kpi-val acv2-kpi-link${unApplied > 0 ? " acv2-kpi-val--danger" : ""}`}
            onClick={(e) => onCreditClick && onCreditClick(e, data.totalUnAppliedCreditMemoAmount, data)}
          >{fmt(unApplied)}</button>
          <div className="acv2-kpi-hint">view credit memos</div>
        </div>
        <div className="acv2-kpi">
          <div className="acv2-kpi-label">Last Payment</div>
          <div className="acv2-kpi-val">{fmt(lastPayAmt)}</div>
          <div className="acv2-kpi-hint">{data.lastPaymentDate || "—"}</div>
        </div>
        <div className="acv2-kpi">
          <div className="acv2-kpi-label">Prov. Paid</div>
          <div className="acv2-kpi-val">{fmt(provPaid)}</div>
        </div>
      </div>

      <button className="acv2-cta-btn" onClick={() => goTo(1)}>
        View Aging Breakdown
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
      </button>
    </div>
  );

  /* ── Step 1: Aging ── */
  const StepAging = (
    <div className="acv2-step">
      <div className="acv2-section-head">
        <div>
          <div className="acv2-section-title">Aging Breakdown</div>
          <div className="acv2-section-sub">{data.customerName}</div>
        </div>
        {isOverdue && <span className="acv2-risk-tag">High Risk</span>}
      </div>

      <div className="acv2-dist-label">Balance distribution</div>
      <div className="acv2-dist-track">
        {agingBuckets.map((b, i) => (
          <div
            key={i}
            className="acv2-dist-seg"
            style={{
              width: totalDue > 0 ? `${(b.value / totalDue) * 100}%` : "0%",
              background: b.color,
            }}
          />
        ))}
        {totalDue === 0 && <div className="acv2-dist-seg" style={{ width: "100%", background: "var(--table-border)" }} />}
      </div>

      <div className="acv2-buckets-list">
        {agingBuckets.map((b) => (
          <BucketCard key={b.label} bucket={b} totalDue={totalDue} />
        ))}
      </div>

      <div className="acv2-total-row">
        <span className="acv2-total-label">Total outstanding</span>
        <span className={`acv2-total-val${totalDue > 0 ? " acv2-total-val--danger" : ""}`}>
          {fmt(totalDue)}
        </span>
      </div>
    </div>
  );

  /* ── Step 2: Payment Info ── */
  const StepPayment = (
    <div className="acv2-step">
      <div className="acv2-section-head">
        <div>
          <div className="acv2-section-title">Payment Info</div>
          <div className="acv2-section-sub">{data.customerName}</div>
        </div>
      </div>
      <div className="acv2-info-cards">
        <div className="acv2-info-card acv2-info-card--accent">
          <div className="acv2-info-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
          </div>
          <div>
            <div className="acv2-info-card-label">Last Payment Amount</div>
            <div className="acv2-info-card-val">{fmt(lastPayAmt)}</div>
          </div>
        </div>
        <div className="acv2-info-card">
          <div className="acv2-info-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
          </div>
          <div>
            <div className="acv2-info-card-label">Last Payment Date</div>
            <div className="acv2-info-card-val acv2-info-card-val--sm">{data.lastPaymentDate || "—"}</div>
          </div>
        </div>
        <div className="acv2-info-card">
          <div className="acv2-info-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          </div>
          <div>
            <div className="acv2-info-card-label">Provisional Paid</div>
            <div className="acv2-info-card-val">{fmt(provPaid)}</div>
          </div>
        </div>
        <div className="acv2-info-card">
          <div className="acv2-info-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
          </div>
          <div>
            <div className="acv2-info-card-label">Current Age Amount</div>
            <div className="acv2-info-card-val">{fmt(currentAge)}</div>
          </div>
        </div>
      </div>
    </div>
  );

  /* ── Step 3: Balance Summary ── */
  const StepBalance = (
    <div className="acv2-step">
      <div className="acv2-section-head">
        <div>
          <div className="acv2-section-title">Balance Summary</div>
          <div className="acv2-section-sub">{data.customerName}</div>
        </div>
      </div>
      <div className="acv2-summary-rows">
        {[
          { label: "Total Due",        val: totalDue,   danger: totalDue > 0,   dot: "#E24B4A", onClick: (e) => onInvoiceClick && onInvoiceClick(e, data.totalInvoiceDueAmount, data), hint: "view invoices" },
          { label: "Unapplied Credit", val: unApplied,  danger: unApplied > 0,  dot: "#BA7517", onClick: (e) => onCreditClick && onCreditClick(e, data.totalUnAppliedCreditMemoAmount, data), hint: "view credit memos" },
          { label: "Current Age Amt",  val: currentAge, danger: false,          dot: "#639922" },
          { label: "Provisional Paid", val: provPaid,   danger: false,          dot: "#3B6D11" },
          { label: "Last Payment",     val: lastPayAmt, danger: false,          dot: "#6b7280" },
        ].map((row) => (
          <div key={row.label} className={`acv2-summary-row${row.danger ? " acv2-summary-row--danger" : ""}`}>
            <div className="acv2-summary-row-left">
              <div className="acv2-summary-dot" style={{ background: row.dot }} />
              <span className="acv2-summary-label">{row.label}</span>
            </div>
            {row.onClick ? (
              <button className={`acv2-summary-link${row.danger ? " acv2-summary-link--danger" : ""}`} onClick={row.onClick}>
                {fmt(row.val)}
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6M10 14L21 3"/></svg>
              </button>
            ) : (
              <span className="acv2-summary-val">{fmt(row.val)}</span>
            )}
          </div>
        ))}
      </div>
      <div className="acv2-net-box">
        <span className="acv2-net-label">Net Outstanding Balance</span>
        <span className={`acv2-net-val${totalDue > 0 ? " acv2-net-val--danger" : ""}`}>{fmt(totalDue)}</span>
      </div>
    </div>
  );

  const steps = [StepProfile, StepAging, StepPayment, StepBalance];

  return (
    <div className="acv2-root">
      {/* Tab bar */}
      <div className="acv2-tabbar">
        {stepLabels.map((label, i) => (
          <button
            key={i}
            className={`acv2-tab${i === step ? " acv2-tab--active" : ""}`}
            onClick={() => goTo(i)}
          >
            <span className="acv2-tab-num">{i + 1}</span>
            <span className="acv2-tab-label">{label}</span>
          </button>
        ))}
      </div>

      {/* Slide viewport */}
      <div
        className="acv2-viewport"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="acv2-slider" style={{ transform: `translateX(-${step * 100}%)` }}>
          {steps.map((panel, i) => (
            <div key={i} className="acv2-slide">{panel}</div>
          ))}
        </div>
      </div>

      {/* Bottom nav */}
      <div className="acv2-bottom-nav">
        <button className="acv2-nav-btn" onClick={() => goTo(step - 1)} disabled={step === 0}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
          Prev
        </button>
        <div className="acv2-dots">
          {Array.from({ length: STEPS }).map((_, i) => (
            <button
              key={i}
              className={`acv2-dot${i === step ? " acv2-dot--active" : ""}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
        <button className="acv2-nav-btn acv2-nav-btn--right" onClick={() => goTo(step + 1)} disabled={step === STEPS - 1}>
          Next
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────
// ✅ Main component
// ─────────────────────────────────────────────────────────────────────
export default function AllCustomerOnlineAgingInquiry() {
  const title = "All Customer Online Aging Inquiry";
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [view, setView] = useState(window.innerWidth <= 768 ? 2 : 1);
  const [code, setCode] = useState("");
  const [agingDataList, setAgingData] = useState([]);
  const [agingBucketList, setAgingBucketData] = useState([]);
  const [agingSummarData, setAgingSummaryData] = useState(null);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);
  const [subTable, setSubTable] = useState(false);
  const [cpmCode, setCpmCode] = useState("");
  const [isFullscreen, setFullscreen] = useState(false);
  const [criteria, setCriteria] = useState(new MultiCustomersPaymentAgingCriteriaBean());
  const [isShowModal, setIsShowModal] = useState(false);
  const [agingHistoryBean, setAgingHistorey] = useState([]);
  const [agingHistoryCreditBean, setAgingCreditHistorey] = useState([]);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const [isShowCreditModal, setIsShowCreditModal] = useState(false);
  const criteriaRef = useRef(null);
  const [customerCode, setCustomerCode] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const isEntityUser = !isEmptyString(session?.entityCode);



      // ── Customer lookup state ──────────────────────────────────────────────────
  const customerCodeRef                                       = useRef(null);
  // Replaced external CustomerLookupHandler with inline CustomerLookupModal
  const [isCustomerLookupOpen, setIsCustomerLookupOpen]       = useState(false);
  const [customerPageListForAutoCompleteList, setCustomerPageListForAutoCompleteList] = useState([]);
  // Start as false — the dropdown must be hidden until the user actually types
  const [showAutoCompleteCustomerList, setShowAutoCompleteCustomerList] = useState(false);
  const [isCustomerNotFound, setIsCustomerNotFound]           = useState(false);
  // Stores the customer description returned by readCustomerWithChildren so
  // addSalesLine can set listRequest.customerName without a second service call.
  const [customerName, setCustomerName]                       = useState("");


  // Count active filters for the badge
 
  const isMobileView = window.innerWidth <= 768;

  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
      setIsMobile(window.innerWidth <= 768);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setFocus();
    asignDefault();
    loadPage(1);
  }, []);

    useEffect(() => {
  // clearAll()
    let criteria = new MultiCustomersPaymentAgingCriteriaBean();
 criteria.companyCode = process.env.REACT_APP_COMPANY;
 setCustomerCode("");

  if (!isEmpty(session)) {
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {
        setCustomerCode(entityCode);
        criteria.customerCodes[0] = entityCode;
      }
    }
  setCriteria(criteria);
  },isFilterOpen);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 2 : 1;
  }
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) setCode(entityCode);
    }
    setFocus();
  }, []);

  const asignDefault = () => {
    const _criteria = new MultiCustomersPaymentAgingCriteriaBean();
    _criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmpty(session)) {
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {
        setCustomerCode(entityCode);
        _criteria.customerCodes[0] = entityCode;
      }
    }
    criteriaRef.current = _criteria;
    setCriteria(_criteria);
  };

  const toggleFullscreen = () => {
    setFullscreen(!isFullscreen);
    if (!isFullscreen) {
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };
  const handleEscapeKey = (event) => {
    if (event.key === "Escape") setFullscreen(false);
  };
  const enterKeyHandler = () => { loadFirst(); };
  const codeOnChange = (e) => { setCode(e.target.value.toUpperCase()); };
  const onChange = (e) => {
    const criteria = new MultiCustomersPaymentAgingCriteriaBean();
    criteria[e.target.name] = e.target.value.toUpperCase();
    setCriteria(criteria);
  };
  const handleCustomerCodeChange = (e) => { setCustomerCode(e.target.value); };
  const buttonHandler = () => { loadFirst(); };
  const listViewHandler = () => { setView(1); };
  const gridViewHandler = () => { setView(2); };
  const onClose = () => { setIsAccessible(false); };

  const notify = (type, msg, theme) => {
    if (type === 1) toast.info(msg, { theme });
    else if (type === 2) toast.error(msg, { theme });
    else if (type === 3) toast.success(msg, { theme });
    else if (type === 4) toast.warn(msg, { theme });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };

  const handleResponse = (response) => {
    let msg = "";
    let msg_List = [];
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data != null) {
          let inquiryList = response.data.onLineAgingResult;
          let agingBucketList = [];
          let agingDataList = [];
          if (inquiryList != null) {
            const bucketGroup = inquiryList.agingBucketGroupBean;
            if (bucketGroup != null) {
              if (!isEmptyArray(bucketGroup.buckets) && bucketGroup.buckets != null) {
                agingBucketList = inquiryList.agingBucketGroupBean.buckets;
                setAgingBucketData(agingBucketList);
              }
            }
            if (!isEmptyArray(inquiryList.agingInfos)) {
              agingDataList = inquiryList.agingInfos;
              setAgingData(agingDataList);
            }
            if (!isEmpty(response.data.onLineAgingResult)) {
              setAgingSummaryData(response.data.onLineAgingResult);
            }
            setIsShowPdf(true);
            setIsShowExcel(true);
          }
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => { msg_List.push(error.messageDescription); });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const loadPage = (id) => {
    setAgingData([]);
    setAgingBucketData([]);
    setIsLoading(true);
    let temp_Criteria = criteriaRef.current;
    if (!isEmptyString(customerCode)) {
      temp_Criteria.customerCodes[0] = customerCode;
    }
    const path = "inquireMultiCustomersOnlineAging";
    service(token, path, temp_Criteria, handleResponse, errorCallBack);
  };

  const loadFirst = () => { loadPage(1); };
  const loadPrevious = () => {
    if (page > 1) loadPage(parseInt(page) - 1);
  };
  const loadNext = () => {
    if (maxPage > page) loadPage(parseInt(page) + 1);
  };
  const loadLast = () => { loadPage(maxPage); };

  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = [];
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` + reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => { msg_List.push(info.messageDescription); });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => { msg_List.push(error.messageDescription); });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };

  const generateReport = (type) => {
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    if (!isEmptyString(criteria.customerCode)) {
      criteria.customerCodes[0] = criteria.customerCode;
    }
    let reportBean = new RestReportBean();
    reportBean.reportType = type;
    let listRequest = new MultiCustomersOnlineAgingPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    const path = "generateMultiCustomersOnlineAgingPrintReport";
    service(token, path, listRequest, handleReportResponse, errorCallBack);
  };

  const PDFHandler = () => { setIsLoading(true); generateReport(1); };
  const ExcelHandler = () => { setIsLoading(true); generateReport(2); };

  const ResetHandler = () => {
    setCode("");
    setAgingData([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setSubTable(false);
    setCpmCode(false);
    setFocus();
    asignDefault();
    setCustomerCode("");
  };

  const ExecuteHandler = () => { loadPage(1); };

  const colButtonHandler = (e, val, row) => {
    setCpmCode(val);
    if (cpmCode == row.cpmCode) {
      if (subTable) { setSubTable(false); setCpmCode(""); }
    }
  };

  const cpmClick = (val, e, row) => {};

  const Columns = () => {
    const _columns = [];
    _columns.push(
      new ColumnDefinition()
        .setDetails("", <PLUSICON />, false)
        .setStyleDetails("center", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, true, cpmClick, <PLUSICON />),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CPM", "code", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setSubTableDetails(true, "taskCode"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ContainerNumber", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    return _columns;
  };

  const viewInvoiceDuePopup = (e, val, rowData) => {
    loadInvoiceDetailList(rowData.customerCode);
    setAgingHistorey([]);
    setAgingCreditHistorey([]);
    setIsShowModal(true);
  };

  const viewCreditAmountPopup = (e, val, rowData) => {
    loadInvoiceDetailList(rowData.customerCode);
    setAgingHistorey([]);
    setAgingCreditHistorey([]);
    setIsShowCreditModal(true);
  };

  const loadInvoiceDetailList = (code) => {
    let criteriaBean = new CustomerPaymentAgingHistoryCriteriaBean();
    criteriaBean.companyCode = process.env.REACT_APP_COMPANY;
    criteriaBean.customerCode = code;
    const path = "inquireCustomerPaymentCurrentAgingHistory";
    service(token, path, criteriaBean, loadInvoiceDetailResponse, errorCallBack);
  };

  const loadInvoiceDetailResponse = (response) => {
    if (response.data != null && response.data.result != null) {
      const agingHistory = response.data.result.agingHistoryBean.invoiceDetails;
      const creditMemoDetail = response.data.result.agingHistoryBean.creditMemoDetails;
      setAgingHistorey(agingHistory);
      setAgingCreditHistorey(creditMemoDetail);
    }
  };

  // ✅ Still needed for the multi-customer table view
  const RattingvalueHandler = (col, row, rate) => {
    if (row.rating === 1) return "bg-yellow";
    else if (row.rating === 2) return "bg-pink";
    else if (row.rating >= 3) return "bg-red";
    else return "bg-green";
  };

  const inquiryColumns = () => {
    const columns = [];
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "4", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson#", "salesPersonCodes", true)
        .setStyleDetails("left", "2", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalDue", "totalInvoiceDueAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, viewInvoiceDuePopup, null)
        .setSubHeaderDetails(true, "allCustomerTotalInvoiceDueAmount"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PH#", "phone1", true)
        .setStyleDetails("left", "4", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "", true)
        .setGraphDetails(true, RattingvalueHandler)
        .setStyleDetails("left", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LastPayDate", "lastPaymentDate", true)
        .setStyleDetails("left", "4", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LastPayAmt", "lastPaymentAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CurrentAgeAmt", "currentAgeAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerCurrentAgeAmount"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("1-30", "ageAmount1", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount1"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("31-60", "ageAmount2", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("61-90", "ageAmount3", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("90+", "ageAmount4", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerAgeAmount4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UnAppliedCredit", "totalUnAppliedCreditMemoAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, viewCreditAmountPopup, null)
        .setSubHeaderDetails(true, "allCustomerTotalCreditMemoAmount"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ProvPaid", "totalProvisionalAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setSubHeaderDetails(true, "allCustomerProvisionalAppliedAmount"),
    );
    return columns;
  };

  const closeModal = () => {
    setIsShowModal(false);
    setIsShowCreditModal(false);
  };

  const openInvoicesDetailColumns = () => {
    const columns = [];
    columns.push(new ColumnDefinition().setDetails("Date", "invoiceDate", true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("Invoice#", "invoiceNumber", true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("SalesPerson#", "salesPersonCodes", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    columns.push(new ColumnDefinition().setDetails("SalesPersonName", "salesPersonNames", true).setStyleDetails("left", "10", "", "wt-3", "wt-3"));
    columns.push(new ColumnDefinition().setDetails("InvoiceAmt", "invoiceAmount", true, true).setStyleDetails("right", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("DueDate", "invoicePaymentDueDate", true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("DueAmt", "invoiceDueAmount", true, true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("ProvPaid", "invoiceProvisionalPaidAmount", true, true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("TotalDue", "invoiceDueAmount", true, true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    return columns;
  };

  const creditMemoDetailColumns = () => {
    const columns = [];
    columns.push(new ColumnDefinition().setDetails("Date", "creditMemoDate", true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("CreditMemo#", "creditMemoNumber", true).setStyleDetails("left", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("TotalAmt", "creditMemoTotalAmount", true, true).setStyleDetails("right", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("AppliedAmt", "apppliedAmount", true, true).setStyleDetails("right", "", "", "wt-2", "wt-2"));
    columns.push(new ColumnDefinition().setDetails("UnAppliedAmt", "unAppliedAmount", true, true).setStyleDetails("right", "", "", "wt-2", "wt-2"));
    return columns;
  };

const clearAll = () =>{
  let criteria = new MultiCustomersPaymentAgingCriteriaBean();
 criteria.companyCode = process.env.REACT_APP_COMPANY;
 setCustomerCode("");

  if (!isEmpty(session)) {
      const { entityCode } = session;
      if (!isEmptyString(entityCode)) {
        setCustomerCode(entityCode);
        criteria.customerCodes[0] = entityCode;
      }
    }
  setCriteria(criteria);

}



 // ── Customer lookup handlers ───────────────────────────────────────────────
    const onCustomerCodeChange = (e) => {
      const customerCode = e.target.value.toUpperCase();
      if (!customerCode) {
        // Field cleared — hide dropdown, reset not-found flag, clear order session
        setShowAutoCompleteCustomerList(false);
        setCustomerPageListForAutoCompleteList([]);
        setIsCustomerNotFound(false);
        setCustomerName("");
        // currentCustomerOrderRef.current = null;
        // lastHeaderKeyRef.current = null;
      } else {
        // Characters typed — show dropdown and kick off the search-as-you-type call
        setShowAutoCompleteCustomerList(true);
        readCustomerBySearchString(e.target.value);
        // Reset order session whenever the customer code changes
        // currentCustomerOrderRef.current = null;
        // lastHeaderKeyRef.current = null;
      }
      setCustomerCode(customerCode)
      // setCriteria((prev) => {
      //   const next = { ...prev, [e.target.name]: customerCode };
      //   criteriaRef.current = next;
      //   return next;
      // });
    };
  
    const customerCodeEnterKeyEventHandler = (e) => {
      readCustomerByCode(e.target.value);
      setCustomerPageListForAutoCompleteList([]);
      setShowAutoCompleteCustomerList(false);
      // Advance focus to the next field in the sequence
     // enterKeyHandler("customerCode");
    };
  
    //   const enterKeyHandler = (fieldName) => {
      
    //   const currentIndex = FIELD_SEQUENCE.indexOf(fieldName);
      
    //   if (currentIndex === -1) return;
    //   const nextField = FIELD_SEQUENCE[currentIndex + 1];
    //   if (nextField) {
    //     focusRef(FIELD_REF_MAP[nextField]);
    //   }
    // };
  
    // Called when user picks a row inside CustomerLookupModal
    const onCustomerLookupSelect = (item) => {
      // setCriteria((prev) => {
      //   const next = { ...prev, customerCode: item.code };
      //   criteriaRef.current = next;
      //   return next;
      // });
        setCustomerCode(customerCode)
      setIsCustomerNotFound(false);
      setCustomerPageListForAutoCompleteList([]);
      setShowAutoCompleteCustomerList(false);
      // currentCustomerOrderRef.current = null;
      // lastHeaderKeyRef.current        = null;
      // Validate/load the selected customer via readCustomerWithChildren
      readCustomerByCode(item.code);
    };
  
    const displayAutoCompleteCustomerList = (show) => {
      setShowAutoCompleteCustomerList(show);
    };
  
    const readCustomerBySearchString = (searchString) => {
      const searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = process.env.REACT_APP_COMPANY;
      // Match by code prefix OR name — uppercase so the server index is hit correctly
      searchCriteria.customerCodeStartsWith = searchString.toUpperCase();
      searchCriteria.customerNameContains   = searchString;
      const pageInput = new RestCustomerListRequest();
      pageInput.pageInput          = new PageListBean();
      pageInput.pageInput.pageSize = 100;
      pageInput.searchCriteria     = searchCriteria;
      service(
        token,
        "getCustomerPageList",
        pageInput,
        (response) => {
          const customers = response?.data?.customerPageList?.customers || [];
          const list = customers
          //  .filter((c) => c.Status === "A")
          .filter((c) => c.Status === "A" || c.status === "A")
          .map((c) => ({ code: c.code, description: c.description }));
          setCustomerPageListForAutoCompleteList(list);
        },
        // Search-as-you-type errors should not flag the field as not-found —
        // that is only done by readCustomerByCode (triggered on Enter / selection).
        () => setCustomerPageListForAutoCompleteList([]),
      );
    };
  
    // readCustomerByCode — called on Enter in the Customer textbox.
    // Uses readCustomerWithChildren (mirrors readCustomer() in SalesOrderMaintenanceModule):
    //   • Builds a RestReadRequest with companyCode, code, isLoadChildren=true
    //   • Calls CustomerService.readCustomerWithChildren
    //   • On success: reads response.data.customer, sets isCustomerNotFound based on
    //     active status (matches readCustomerResponse in maintenance module)
    //   • On error: marks customer as not found
    const readCustomerByCode = (customerCode) => {
      if (!customerCode) return;
      const readRequest = new RestReadRequest();
      readRequest.companyCode   = process.env.REACT_APP_COMPANY;
      readRequest.code          = customerCode.toUpperCase();
      readRequest.isLoadChildren = true;
       service(token,"readCustomerWithChildren",readRequest,
        (response) => {
          const customerData = response?.data?.customer;
          if (customerData) {
            // Inactive customers are flagged as "not found" — mirrors readCustomerResponse
            const isInactive = customerData.isActive === false;
            setIsCustomerNotFound(isInactive);
            if (isInactive) {
              notify(TOAST_WARN, "Customer is InActive");
              setCustomerName("");
           
            } else {
              // Persist the name so addSalesLine can populate listRequest.customerName
              // setCustomerName(customerData.description || "");
              // setPaymentTerms(customerData.paymentTermsCode || "");
              // setPaymentMethodCode(customerData.paymentMethodCode || "");
              //  setCustomerTypeCode(customerData.customerTypeCode || "");
              // setCreatedBy(customerData.createdBy || "");
             
             setCustomerName(customerData);
  
            }
          } else {
            setIsCustomerNotFound(true);
            setCustomerName("");
  
  
          }
        },
        () => { setIsCustomerNotFound(true); setCustomerName(""); },
      );
    };

  return (
    <>
      {isLoading ? <Loader /> : null}

      <Modal isOpen={isShowModal} onClose={closeModal} title={"Open Invoices"}>
        <div className="model-fw">
           <MobileCardTable
                columns={openInvoicesDetailColumns()}
                data={agingHistoryBean}
                codeAccessor="invoiceNumber"
             
                // onPDF={(row) => PDFHandler(row.code)}
                // onMoreOption={(row) => MoreOptionHandler(row.code)}
              />
          {/* <CustomTable
            data={agingHistoryBean}
            columns={openInvoicesDetailColumns}
            isEnableSpan={true}
          /> */}
        </div>
      </Modal>

      <Modal isOpen={isShowCreditModal} onClose={closeModal} title={"Open CreditMemos"}>
        <div className="model-fw">
            <MobileCardTable
                columns={creditMemoDetailColumns()}
                data={agingHistoryCreditBean}
                codeAccessor="creditMemoNumber"
             
                // onPDF={(row) => PDFHandler(row.code)}
                // onMoreOption={(row) => MoreOptionHandler(row.code)}
              />
          {/* <CustomTable
            data={agingHistoryCreditBean}
            columns={creditMemoDetailColumns}
          /> */}
        </div>
      </Modal>

      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />

      {/* ── DESKTOP inline row ── */}
      {!isEntityUser && (
        <div className="card-body search-container module-filter-desktop">
          <div className="row aging-filter-row">
            <div className="form-group aging-filter-group--wide">
              <InputTextBox
                // value={customerCode}
                // name="customerCode"
                // placeholder="Enter CustomerNumber"
                // label="Customer"
                // onChange={handleCustomerCodeChange}
                                     onChange={onCustomerCodeChange}
                  ref={customerCodeRef}
                  name="customerCode"
                  placeholder="Customer"
                  value={customerCode}
                  enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                  autoCompleteListData={customerPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteCustomerList}
                  showAutoCompleteList={showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={isCustomerNotFound}
                  label="Customer"
                  inputRef={inputRef}
                  lookupList={customerPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteCustomerList && customerPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onCustomerLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteCustomerList(false)}
                    disable={disable}
              />
            </div>
            
            <div className="form-group aging-filter-group--wide">
              <CustomButton buttonHandler={buttonHandler} label="Fetch" />
                  <CustomButton buttonHandler={ResetHandler} label="Reset" />
            </div>
          </div>
        </div>
      )}
      {/* ── MOBILE action bar ── */}
        {isMobile && (
      <div className="module-filter-mobile mobile-filter-bar">
        {!isEntityUser ? (
          <button className="mobile-filter-pill" onClick={() => setIsFilterOpen(true)}>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="none"
              stroke="currentColor" strokeWidth="2.2">
              <line x1="2" y1="4" x2="14" y2="4"/>
              <line x1="4" y1="8" x2="12" y2="8"/>
              <line x1="6" y1="12" x2="10" y2="12"/>
            </svg>
            Filters
          
          </button>
        ) : (
          <span className="aging-spacer" />
        )}
      <div className="aging-mobile-actions">
            <button className="mobile-action-btn" onClick={buttonHandler}>Fetch</button>
            {!isEntityUser && (
              <button className="mobile-action-btn outline" onClick={ResetHandler}>Reset</button>
            )}
          </div>
      </div>
        )}

      {/* ── MOBILE: active chips + overlay + bottom sheet (hidden on desktop via CSS) ── */}
      <div className="module-filter-mobile aging-mobile-filter-col">

       

        {/* Overlay — tap outside to close */}
        {isFilterOpen && (
          <div className="mobile-filter-overlay" onClick={() => setIsFilterOpen(false)} />
        )}

        {/* Bottom sheet */}
        <div className={`mobile-filter-sheet${isFilterOpen ? " is-open" : ""}`}>
          <div className="mobile-sheet-handle" />

          {/* Sheet header: title | clear all | × close */}
          <div className="mobile-sheet-header">
            <span className="mobile-sheet-title">Filters</span>
            <div className="mobile-sheet-header-actions">
              <button className="mobile-sheet-clear" onClick={() => {
              clearAll()
              }}>Clear all</button>
              <button className="mobile-sheet-close" onClick={() => setIsFilterOpen(false)}>×</button>
            </div>
          </div>

          {/* Filter inputs */}
          <div className="mobile-sheet-body">
            <div className="mobile-filter-row">
                {!isEntityUser && (
              <span className="mobile-filter-label">Customer Number</span>
                )}
                  {!isEntityUser && (
              <InputTextBox 
              // value={customerCode} name="customerCode"
              //   placeholder="Enter customer number" onChange={handleCustomerCodeChange} 
               onChange={onCustomerCodeChange}
                  ref={customerCodeRef}
                  name="customerCode"
                  placeholder="Customer"
                  value={customerCode}
                  enterKeyEventHandler={customerCodeEnterKeyEventHandler}
                  autoCompleteListData={customerPageListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={displayAutoCompleteCustomerList}
                  showAutoCompleteList={showAutoCompleteCustomerList}
                  isMandatory={true}
                  isNotFound={isCustomerNotFound}
                  label="Customer"
                  inputRef={inputRef}
                  lookupList={customerPageListForAutoCompleteList}
                  showLookupDropdown={showAutoCompleteCustomerList && customerPageListForAutoCompleteList.length > 0}
                  onLookupSelect={(item) => onCustomerLookupSelect(item)}
                  onHideLookupDropdown={() => setShowAutoCompleteCustomerList(false)}
                    disable={disable}
                
                />
                  )}
            </div>
          
          </div>

          <button className="mobile-sheet-apply" onClick={() => {
            setIsFilterOpen(false);
            buttonHandler();
          }}>
            Apply Filters
          </button>
        </div>

      </div>

       <ViewToggle
                    listViewHandler={listViewHandler}
                    gridViewHandler={gridViewHandler}
                  />
      {!isEmptyArray(agingDataList) ? (
        
        <div className="card-body">
           
          <div className={`header_div table-wrap ${isFullscreen ? "full-screen" : ""}`}>
            
            <div className="card-title">
              <h1>Aging Report Details</h1>
            </div>
            <div className="fullScreen-toggle">
              {isFullscreen ? (
                <MdFullscreenExit onClick={toggleFullscreen} className="full-screen-toggle" />
              ) : (
                <MdFullscreen onClick={toggleFullscreen} className="full-screen-toggle" />
              )}
            </div>
           
              {/* ✅ 1 customer → card view | multiple → table */}
              {agingDataList.length === 1 ? (
               <div className="mt-3">
                <AgingCustomerCard
                  data={agingDataList[0]}
                  onInvoiceClick={viewInvoiceDuePopup}
                  onCreditClick={viewCreditAmountPopup}
                />
                   </div>
              ) : (
                
                <>
                
                  <div className="list-wrap">
                    {view === 1 ? (
                      <CustomTable
                        data={agingDataList}
                        columns={inquiryColumns}
                        subHeaderData={agingSummarData}
                        isEnableSpan={true}
                      />
                    ) : (
                      <MobileCardTable
                        columns={inquiryColumns()}
                        data={agingDataList}
                        codeAccessor="customerCode"
                        subAccessor="customerName"
                        subHeaderData={agingSummarData}
                      />
                    )}
                  </div>
                </>
              )}
            
          </div>
        </div>
      ) : null}

      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}